import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Layout, Form, Input, Button, Checkbox, Typography, Space, Row, Col } from 'antd';


import LandingImage from './Logos/rubus_login_bm.jpg';
import LoginAction from '../../../modules/actions/LoginAction';
import TranslationAction from '../../../modules/actions/TranslationAction';
import rubusLogo from '../../../images/horizontal_logo.png';
import customerLogo from '../../../images/horizontal_logo_biomass.png';
import './Login.css';

const { Title } = Typography;
const { Content, Footer } = Layout;

const LoginComponent = ({ accessToken, translationCache, loginAction }) => {
  const location = useLocation();
  const [siteName, setSiteName] = useState('');
  const [showSite, setShowSite] = useState(false);

  useEffect(() => {
    const path = location.pathname.split('/login/');
    if (path && path[1]) {
      setSiteName(path[1]);
      setShowSite(false);
    } else {
      setShowSite(true);
    }
  }, [location.pathname]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onFinish = (values) => {
    if (!showSite) {
      values = { ...values, siteName };
    }
    loginAction.userLoginAuth(values);
  };

  if (accessToken && accessToken !== 'undefined' && accessToken !== 'null') {
    return <Navigate to="/rubus/LandingPage" />;
  }

  return (
    <Layout className="rubus-layout">
      {/* Global Background */}
      <Content className="rubus-content">
        <Row justify="center" gutter={[16, 16]} className="rubus-row">
          {/* Left Column - Image Section */}
          <Col xs={0} sm={0} md={16} lg={14} xl={14} className="rubus-column-left">
            <div className="rubus-company-name">
              <img src={rubusLogo} alt="Company Logo" />
            </div>
            <div className="rubus-illustration">
              <img src={LandingImage} alt="Illustration" />
            </div>
          </Col>

          {/* Right Column - Login Form Section */}
          <Col xs={24} sm={24} md={8} lg={10} xl={10} className="rubus-column-right">
            <div className="rubus-login-container">
              <div className="logo-container">
                <img src={customerLogo} alt="Logo" />
              </div>
              <Title level={3} style={{ textAlign: 'center', marginBottom: '10px' }}>
                Welcome back!
              </Title>
              <Title level={4} style={{ textAlign: 'center', color: '#00277f', marginBottom: '10px' }}>
                {showSite === false ? (
                  <div>{`${_.startCase(_.toLower(siteName))} Application`}</div>
                ) : null}
              </Title>
              <p style={{ textAlign: 'center', marginBottom: '20px' }}>Please enter your details</p>
              <Form
                name="login"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                style={{ maxWidth: '100%' }}
              >
                {showSite === true ? (
                  <Form.Item
                    name="siteName"
                    rules={[{ required: true, message: translation('Please input your Site Name') }]}
                  >
                    <Input placeholder="Site" size="large" />
                  </Form.Item>
                ) : null}
                <Form.Item
                  name="identifier"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your email!',
                    },
                  ]}
                >
                  <Input placeholder="Email" size="large" />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your password!',
                    },
                  ]}
                >
                  <Input.Password placeholder="Password" size="large" />
                </Form.Item>

                <Form.Item name="remember" valuePropName="checked">
                  <Checkbox style={{ color: 'white', fontWeight: 'bold' }}>Remember me</Checkbox>
                </Form.Item>

                <Form.Item>
                  <Space direction="vertical" style={{ width: '100%' }}>
                    <Button
                      type="primary"
                      style={{ background: '#00277f' }}
                      htmlType="submit"
                      block
                      size="large"
                    >
                      Log In
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Content>

      {/* Footer Section - Positioned at the bottom right corner */}
      <Footer className="rubus-footer">
        <p>© 2025 Rubus. All rights reserved.</p>
      </Footer>
    </Layout>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginAction: bindActionCreators(LoginAction, dispatch),
    TranslationAction: bindActionCreators(TranslationAction, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    accessToken: state.LoginReducer.accessToken,
    translationCache: state.TranslationReducer?.translations || {},
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);


